<app-diet-detail
  *ngIf="diet"
  [isMobile]="true"
  [diet]="diet"
  [userId]="userId"
></app-diet-detail>
